export default __webpack_public_path__ + "static/media/astropay-isotipo-bw.d59cc4e7.svg";